/**
 * Criteo OneTag — beastlife.in
 * Single drop-in file. No Liquid required.
 *
 * Install (theme):
 *   1. Assets > Add a new asset > upload this file as `criteo.js`
 *   2. layout/theme.liquid, immediately before </body>:
 *        <script src="{{ 'criteo.js' | asset_url }}" defer></script>
 *
 * Install (GoKwik thank-you page):
 *   Paste the whole file inside <script> tags in
 *   GoKwik dashboard > Settings > Custom Scripts > Thank You page.
 *   It detects window.order and fires only trackTransaction there.
 *
 * Optional (better match rate, needs one Liquid line in theme.liquid
 * ABOVE the script tag above):
 *   <script>window.CRITEO_EMAIL_SHA256 = "{{ customer.email | downcase | strip | sha256 }}";</script>
 *
 * Debug: append ?criteo_debug=1 to any URL, or run
 *   localStorage.setItem('criteo_debug', '1')
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------- config
  var CONFIG = {
    account: 129409,

    // 'variant' -> Shopify variant ID (e.g. 48921380094229)
    // 'product' -> Shopify product ID (e.g. 9331460636949)
    // MUST match the id field in the catalog feed Criteo ingests.
    idType: 'variant',

    // Fire viewList on /pages/* landing pages (byob, buy-4-1999, offers...)
    // when 3+ product links are present. These pages carry real traffic.
    listOnLandingPages: true,

    // Fire viewBasket when the GoKwik side cart opens (not just /cart).
    basketOnSideCart: true,

    currency: 'INR'
  };

  // ---------------------------------------------------------------- guards
  if (window.__criteoTagLoaded) return;
  window.__criteoTagLoaded = true;

  var DEBUG = false;
  try {
    DEBUG = /[?&]criteo_debug=1/.test(location.search) ||
            localStorage.getItem('criteo_debug') === '1';
  } catch (e) {}

  function log() {
    if (!DEBUG) return;
    var args = ['%c[criteo]', 'color:#f60;font-weight:bold'].concat([].slice.call(arguments));
    console.log.apply(console, args);
  }

  // ---------------------------------------------------------------- loader
  function loadOneTag() {
    if (document.querySelector('script[src*="dynamic.criteo.com/js/ld/ld.js"]')) return;
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//dynamic.criteo.com/js/ld/ld.js?a=' + CONFIG.account;
    (document.head || document.body || document.documentElement).appendChild(s);
  }

  // ---------------------------------------------------------------- helpers
  function deviceType() {
    var ua = navigator.userAgent;
    if (/iPad/.test(ua)) return 't';
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(ua)) return 'm';
    return 'd';
  }

  function visitorId() {
    try {
      var k = '_criteo_vid';
      var v = localStorage.getItem(k);
      if (!v) {
        v = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem(k, v);
      }
      return v;
    } catch (e) {
      return '';
    }
  }

  function customerId() {
    try {
      if (window.__st && window.__st.cid) return String(window.__st.cid);
      if (window.ShopifyAnalytics &&
          ShopifyAnalytics.meta &&
          ShopifyAnalytics.meta.page &&
          ShopifyAnalytics.meta.page.customerId) {
        return String(ShopifyAnalytics.meta.page.customerId);
      }
    } catch (e) {}
    return '';
  }

  function baseEvents() {
    var base = [{ event: 'setAccount', account: CONFIG.account }];

    if (window.CRITEO_EMAIL_SHA256) {
      base.push({
        event: 'setEmail',
        email: window.CRITEO_EMAIL_SHA256,
        hash_method: 'sha256'
      });
    }

    var cid = customerId();
    if (cid) base.push({ event: 'setCustomerId', id: cid });

    base.push({ event: 'setSiteType', type: deviceType() });
    base.push({ event: 'setRetailerVisitorId', id: visitorId() });
    return base;
  }

  function push(payload) {
    if (!payload) return;
    window.criteo_q = window.criteo_q || [];
    var batch = baseEvents().concat([payload]);
    log(payload.event, payload);
    window.criteo_q.push.apply(window.criteo_q, batch);
  }

  function money(cents) {
    var n = parseFloat(cents);
    if (isNaN(n)) return '0.00';
    return (n / 100).toFixed(2);
  }

  // id resolution — one place, driven by CONFIG.idType
  function idFrom(productId, variantId) {
    if (CONFIG.idType === 'product') return productId ? String(productId) : '';
    return variantId ? String(variantId) : (productId ? String(productId) : '');
  }

  // /cart.js and /cart/add.js line item shape:
  //   { id: <variantId>, product_id: <productId>, final_price, price, quantity }
  function lineToItem(li) {
    return {
      id: idFrom(li.product_id, li.variant_id || li.id),
      price: money(li.final_price != null ? li.final_price : li.price),
      quantity: li.quantity || 1
    };
  }

  // ---------------------------------------------------------------- page type
  function pageType() {
    var t = '';
    try {
      if (window.ShopifyAnalytics &&
          ShopifyAnalytics.meta &&
          ShopifyAnalytics.meta.page &&
          ShopifyAnalytics.meta.page.pageType) {
        t = ShopifyAnalytics.meta.page.pageType;
      }
    } catch (e) {}

    if (t) return t;

    // Fallback: URL based
    var p = location.pathname.replace(/\/+$/, '') || '/';
    if (p === '/') return 'home';
    if (p.indexOf('/products/') !== -1) return 'product';
    if (p.indexOf('/search') === 0) return 'searchresults';
    if (p.indexOf('/cart') === 0) return 'cart';
    if (p.indexOf('/collections') === 0) return 'collection';
    if (p.indexOf('/pages/') === 0) return 'page';
    return 'other';
  }

  // ---------------------------------------------------------------- viewItem
  function selectedVariantId(meta) {
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    if (meta && meta.variants && meta.variants.length) return String(meta.variants[0].id);
    return '';
  }

  function fireViewItem() {
    var meta = null;
    try {
      meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    } catch (e) {}

    if (!meta || !meta.id) {
      log('viewItem skipped — ShopifyAnalytics.meta.product missing');
      return;
    }

    var vid = selectedVariantId(meta);
    var variant = null;
    for (var i = 0; i < (meta.variants || []).length; i++) {
      if (String(meta.variants[i].id) === vid) { variant = meta.variants[i]; break; }
    }
    if (!variant && meta.variants && meta.variants.length) variant = meta.variants[0];

    var atc = document.querySelector('[name="add"]');
    var available = atc ? (atc.disabled ? 0 : 1) : 1;

    push({
      event: 'viewItem',
      item: idFrom(meta.id, variant && variant.id),
      price: variant ? money(variant.price) : '0.00',
      availability: available
    });
  }

  // ---------------------------------------------------------------- viewList
  function handlesFromDom(limit) {
    var seen = {};
    var out = [];
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length && out.length < limit; i++) {
      var m = links[i].getAttribute('href').match(/\/products\/([a-z0-9\-_%]+)/i);
      if (!m) continue;
      var h = m[1].toLowerCase();
      if (seen[h]) continue;
      seen[h] = true;
      out.push(h);
    }
    return out;
  }

  function fireViewList(extra) {
    // 1. Cheap path — Shopify already put the products in the analytics meta
    var metaProducts = null;
    try {
      metaProducts = window.ShopifyAnalytics &&
                     ShopifyAnalytics.meta &&
                     ShopifyAnalytics.meta.products;
    } catch (e) {}

    if (metaProducts && metaProducts.length) {
      var ids = [];
      for (var i = 0; i < metaProducts.length && ids.length < 3; i++) {
        var p = metaProducts[i];
        var v = p.variants && p.variants[0];
        var id = idFrom(p.id, v && v.id);
        if (id) ids.push(id);
      }
      if (ids.length) {
        push(mergeList({ event: 'viewList', item: ids }, extra));
        return;
      }
    }

    // 2. Product IDs only — no fetch needed
    if (CONFIG.idType === 'product') {
      var handles = handlesFromDom(3);
      if (!handles.length) { log('viewList skipped — no product links found'); return; }
      Promise.all(handles.map(fetchProduct)).then(function (products) {
        var pids = products.filter(Boolean).map(function (p) { return String(p.id); });
        if (pids.length) push(mergeList({ event: 'viewList', item: pids }, extra));
      });
      return;
    }

    // 3. Variant IDs — need the product JSON for the first available variant
    var hs = handlesFromDom(3);
    if (!hs.length) { log('viewList skipped — no product links found'); return; }
    Promise.all(hs.map(fetchProduct)).then(function (products) {
      var out = [];
      products.forEach(function (p) {
        if (!p) return;
        var v = null;
        for (var i = 0; i < (p.variants || []).length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        if (!v) v = p.variants && p.variants[0];
        var id = idFrom(p.id, v && v.id);
        if (id) out.push(id);
      });
      if (out.length) push(mergeList({ event: 'viewList', item: out }, extra));
    });
  }

  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function mergeList(payload, extra) {
    if (extra) for (var k in extra) if (extra[k]) payload[k] = extra[k];
    return payload;
  }

  // ---------------------------------------------------------------- viewBasket
  var lastBasketAt = 0;
  function fireViewBasket(force) {
    var now = Date.now();
    if (!force && now - lastBasketAt < 3000) return;
    lastBasketAt = now;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) {
          log('viewBasket skipped — empty cart');
          return;
        }
        push({
          event: 'viewBasket',
          currency: cart.currency || CONFIG.currency,
          item: cart.items.map(lineToItem).filter(function (i) { return i.id; })
        });
      })
      .catch(function (e) { log('cart.js failed', e); });
  }

  // ---------------------------------------------------------------- addToCart
  function fireAddToCart(res) {
    if (!res) return;
    var lines = res.items ? res.items : [res];
    var items = lines
      .filter(function (l) { return l && (l.id || l.variant_id); })
      .map(lineToItem)
      .filter(function (i) { return i.id; });

    if (!items.length) return;
    push({ event: 'addToCart', currency: CONFIG.currency, item: items });
  }

  function interceptCartAdd() {
    var RE = /\/cart\/add(\.js)?(\?|$)/;

    // fetch — used by Dawn's product-form.js, global-sticky-atc,
    // all the bundle/byob sections, and GoKwik
    var _fetch = window.fetch;
    if (_fetch) {
      window.fetch = function (input) {
        var url = (input && input.url) ? input.url : String(input);
        var p = _fetch.apply(this, arguments);
        if (RE.test(url)) {
          p.then(function (res) {
            res.clone().json().then(fireAddToCart).catch(function () {});
          }).catch(function () {});
        }
        return p;
      };
    }

    // XHR — GoKwik's side cart and any jQuery-based section
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__criteoAdd = RE.test(String(url));
      return _open.apply(this, arguments);
    };
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__criteoAdd) {
        this.addEventListener('load', function () {
          try { fireAddToCart(JSON.parse(this.responseText)); } catch (e) {}
        });
      }
      return _send.apply(this, arguments);
    };

    // Native form POST (byob.liquid, sharktank-combos.liquid) — the page
    // navigates away, so read the form fields at submit time.
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.action || !RE.test(form.action)) return;

      var fd;
      try { fd = new FormData(form); } catch (e) { return; }
      var ids = fd.getAll ? fd.getAll('id') : [fd.get('id')];
      var qty = fd.get('quantity') || 1;
      if (!ids || !ids.length || !ids[0]) return;

      // Native POST gives us the variant id but no price. In product mode we
      // can't resolve the product id without a lookup, so send variant only
      // when idType is 'variant'; otherwise let the resulting /cart page fire
      // viewBasket instead.
      if (CONFIG.idType !== 'variant') return;

      push({
        event: 'addToCart',
        currency: CONFIG.currency,
        item: ids.filter(Boolean).map(function (id) {
          return { id: String(id), price: '0.00', quantity: parseInt(qty, 10) || 1 };
        })
      });
    }, true);
  }

  // ---------------------------------------------------------------- side cart
  function watchSideCart() {
    if (!CONFIG.basketOnSideCart) return;

    // GoKwik mounts a .sidecart node into <body> when the drawer opens.
    // Watching the DOM is more reliable than wrapping openGokwikSideCart,
    // which is defined by a deferred script that runs after this one.
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('sidecart')) { fireViewBasket(); return; }
          if (n.querySelector && n.querySelector('.sidecart')) { fireViewBasket(); return; }
        }
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });

    // Belt and braces — if the global exists by the time we poll, wrap it too.
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (typeof window.openGokwikSideCart === 'function' && !window.openGokwikSideCart.__criteo) {
        var orig = window.openGokwikSideCart;
        var wrapped = function () {
          try { fireViewBasket(); } catch (e) {}
          return orig.apply(this, arguments);
        };
        wrapped.__criteo = true;
        window.openGokwikSideCart = wrapped;
        clearInterval(iv);
      }
      if (tries > 60) clearInterval(iv);
    }, 400);
  }

  // ---------------------------------------------------------------- purchase
  // Runs only where a GoKwik order object exists (thank-you page).
  function tryPurchase() {
    var o = window.order || window.orderData;
    if (!o) return false;

    var lines = o.line_items || o.lineItems || o.items;
    if (!lines || !lines.length) return false;

    var txn = String(
      o.order_number || o.orderNumber || o.name || o.order_id || o.id || ''
    );
    if (!txn) return false;

    try {
      var k = '_criteo_txn_' + txn;
      if (sessionStorage.getItem(k)) { log('purchase already fired', txn); return true; }
      sessionStorage.setItem(k, '1');
    } catch (e) {}

    var items = lines.map(function (li) {
      var pid = li.product_id || li.productId;
      var vid = li.variant_id || li.variantId || li.id;
      var raw = li.price != null ? li.price : (li.final_price != null ? li.final_price : 0);
      var p = parseFloat(raw);
      // GoKwik sometimes echoes Shopify's paise. Integers this large are paise.
      if (p > 10000 && p % 1 === 0) p = p / 100;
      return {
        id: idFrom(pid, vid),
        price: p.toFixed(2),
        quantity: li.quantity || 1
      };
    }).filter(function (i) { return i.id; });

    if (!items.length) return false;

    push({
      event: 'trackTransaction',
      id: txn,
      new_customer: (o.customer && o.customer.orders_count > 1) ? 0 : 1,
      currency: o.currency || CONFIG.currency,
      item: items
    });

    return true;
  }

  // ---------------------------------------------------------------- init
  function init() {
    loadOneTag();

    // Thank-you page: fire the sale and nothing else.
    if (tryPurchase()) return;

    interceptCartAdd();
    watchSideCart();

    var type = pageType();
    log('pageType', type, 'idType', CONFIG.idType);

    switch (type) {
      case 'home':
        push({ event: 'viewHome' });
        break;

      case 'product':
        fireViewItem();
        break;

      case 'collection':
        fireViewList({
          category: (location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1] || ''
        });
        break;

      case 'searchresults':
        var qm = location.search.match(/[?&]q=([^&]*)/);
        fireViewList({
          keywords: qm ? decodeURIComponent(qm[1].replace(/\+/g, ' ')) : ''
        });
        break;

      case 'cart':
        fireViewBasket(true);
        break;

      case 'page':
        if (CONFIG.listOnLandingPages) {
          var handles = handlesFromDom(3);
          if (handles.length >= 3) {
            fireViewList({
              category: (location.pathname.match(/\/pages\/([^/?#]+)/) || [])[1] || ''
            });
          }
        }
        break;

      default:
        break;
    }
  }

  // Expose for manual testing in the console.
  window.CriteoTag = {
    config: CONFIG,
    push: push,
    viewBasket: function () { fireViewBasket(true); },
    viewItem: fireViewItem,
    viewList: fireViewList,
    pageType: pageType,
    debug: function (on) {
      try { localStorage.setItem('criteo_debug', on === false ? '0' : '1'); } catch (e) {}
      location.reload();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();